export const pkg = {
  name: 'isomorphic-git',
  version: '1.32.1',
  agent: 'git/isomorphic-git@1.32.1',
}
